import ClientInvoiceSearchParams from '../Contents/Operations/ClientInvoiceAdmin/ClientInvoiceSearchParams';

export default class MassFinalizeItem {
  constructor() {
    this.IdListString = '';
    this.AllItemsInTheSearchSetAreSelected = false;
    this.NumberOfItemsSelected = 0;
    this.SearchItem = new ClientInvoiceSearchParams();
  }
}
